import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';

import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector } from 'js/store/hooks';

export const useNavigateToPrevPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const rootPage = useAppSelector(prop('rootPage'));
    const { prevPath } = location.state || {};

    return useCallback(() => {
        navigate(prevPath || rootPage);
    }, [prevPath, rootPage, navigate]);
};
